module.exports = __webpack_public_path__ + "static/media/warning-yellow.abcc6161.svg";